import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SiteWrapper from 'components/SiteWrapper/SiteWrapper';
import { connect } from 'react-redux';
import DataTable from 'components/DataTable/DataTable';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import { DarkBackground, Spinner } from 'elements/Spinner/Spinner.styled';
import { MatchSRA } from 'helpers/Validation';
import { updatedTableDefinitionNonMo } from '../TagSelectionMOScreen/TagSelectionMOScreen.constants';
import { setHdLocationSortOrder, searchFLOC } from './TagSelectionNonMoScreen.action';
import { parseDate } from '../../../helpers/DateFormatter';
import {
  setDataForFormTagSelected, clearSelectedTRF,
  getAllMOImages, setIsEditimage, clearEditImageList, resetTestPointVal,
  saveSpinnerVisibleData,
  clearLateEntryDPSData
} from '../Forms/Forms.actions';
import { MRAT_USER_ROLE, NONMO_USER_ROLE } from '../Home/Home.constants';
import SearchBox from '../../../elements/SearchBox/SearchBox';
import { checkOfflineDataPresent, sendOfflineData, setCurrentView, setPreviousScreen } from '../Home/Home.actions';
import { clearSRAData, GetP8ITFForm } from '../Forms/FormsP8.actions';
import { getPrintImage } from '../Forms/TRFImaging.actions';
import { isMobile as isTablet } from 'react-device-detect';

const TagSelectionMOScreenPage = (props) => {
  const { setCurrentAppView, totalCount, selectedRowTags, triggerSort, userRole,
    initialiseDataForFormTagSelected, isMRATOnline, clearSelectedTRFValue, clearFilters, selectedRowTagsTableData, searchedRowTagsTableData,
    setIsEditImage, clearEditimageList, fetchAllImages, isTableLoading, deleteSRAData, loadP8ITFForm, fetchTRFImages,
    flocSearchString, triggerSearch, clearTestPointValue, trfMasterList, setPreviousAppScreen, saveSpinnerVisible, isOfflineDataPresent, checkOfflineFormDataPresent, homeDraftData, IsLateEntry, clerLateEntryDpsData } = props;
  const [searchString, setSearchString] = useState(flocSearchString);
  const [searchByTester, setSearchByTester] = useState('');
  let tableData = [];
  if (clearFilters && searchString.length === 0 && searchByTester.length === 0) {
    tableData = selectedRowTags;
  } else if (searchString || searchByTester) {
    tableData = searchedRowTagsTableData.filter((row) => {
      const matchesLocation = searchString
        ? row.HdLocation?.toLowerCase().includes(searchString.toLowerCase())
        : true;
      const matchesTester = searchByTester
        ? row.CreatedBy?.toLowerCase().includes(searchByTester.toLowerCase())
        : true;
      return matchesLocation && matchesTester;
    });
  } else {
    tableData = selectedRowTagsTableData;
  }
  const [printButtonVisible, setPrintButtonVisible] = useState(false);
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const showGrid = isMRATOnline && !isTablet && (MRAT_USER_ROLE.View !== userRole);
  let checkedFormsData = [];
  useEffect(() => {
    deleteSRAData();
    clearTestPointValue();
    saveSpinnerVisible(true);
    homeDraftData();
    clearSelectedTRFValue();
    setPreviousAppScreen('');
    clerLateEntryDpsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMRATOnline]);
  useEffect(() => {
    flocSearchString && handleSearch(flocSearchString, 'FunctionalLocation');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowTagsTableData]);

  const sortButtonHandler = (columnName) => {
    triggerSort(columnName);
  };

  const handleArrowButton = (dataRow, isMRATOnlineParameter) => {
    initialiseDataForFormTagSelected(dataRow);
    if (isMRATOnlineParameter || !dataRow.TrfRowId) {
      // There are 3 places in redux store state where the form will fetch the data from:
      // Forms: formData
      // Forms: selectedTag
      // Forms: selectedTrfId
      // All of the above data must be cleared first
      clearSelectedTRFValue();
      if (trfMasterList.find(x => x.TrfId === dataRow.TrfId.trim())?.Status === 'Inactive') {
        setCurrentAppView('NA');
      } else if (dataRow.TrfId.trim() !== '') {
        setCurrentAppView(dataRow.TrfId.trim());
      } else {
        setCurrentAppView('NA');
      }
      fetchAllImages();
      MatchSRA(dataRow?.TrfId?.trim()) && loadP8ITFForm(dataRow).finally(() => saveSpinnerVisible(false));
    }
    setIsEditImage(false, {});
    clearEditimageList();
  };
  useEffect(() => {
    checkOfflineFormDataPresent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOfflineDataPresent, isMRATOnline]);

  const getParsedTableData = (isMRATOnlineParameter, userRoleParameter) => tableData?.map((item) => ({
    ...item,
    MO: item.HdWorkOrder,
    DateTimeTested: item.CreatedDate ? new Date(item.CreatedDate) : '',
    CreatedDate: item.CreatedDate ? parseDate(item.CreatedDate) : '',
    HideArrow:
      // No one can see already filled forms in the OFFLINE MODE
      (!isMRATOnlineParameter && item.TrfRowId)
      // Only technicians are allowed to open unfilled forms
      || ((MRAT_USER_ROLE.View === userRoleParameter) && item.TrfRowId)
      || (isMRATOnline && isOfflineDataPresent),
  }));
  const handleSearch = (searchValue, searchType) => {
    if (searchType === 'FunctionalLocation') {
      setSearchString(searchValue);
      triggerSearch(searchValue, selectedRowTags?.HdWorkOrder);
    } else if (searchType === 'FirstTestDoneBy') {
      setSearchByTester(searchValue);
    }
  };
  const handlePrintButtonVisible = (visibleState, checkedRecords) => {
    setPrintButtonVisible(visibleState);
    checkedFormsData = [...checkedRecords];
  };

  const handlePrintButton = async () => {
    setSpinnerVisible(true);
    const trfImages = await fetchTRFImages(checkedFormsData);
    const imgData = [];
    _.forEach(trfImages, (ele) => {
      imgData.push(`data:image/png;base64, ${ele.Trfimage1}`);
      ele.Trfimage2 && imgData.push(`data:image/png;base64, ${ele.Trfimage2}`);
      ele.Trfimage3 && imgData.push(`data:image/png;base64, ${ele.Trfimage3}`);
    });

    // hidden iframe to preview all the images on print screen
    const iframe = document.createElement('iframe');
    iframe.style.height = 0;
    iframe.style.visibility = 'hidden';
    iframe.style.width = 0;
    iframe.style.overflowX = 'visible';
    iframe.setAttribute('srcdoc', '<html><body></body></html>');
    document.body.appendChild(iframe);

    iframe.addEventListener('load', () => {
      const { body } = iframe.contentDocument;
      const div = document.createElement('div');
      div.style.position = 'absolute';
      div.style.display = 'block';
      div.style.left = 0;
      div.style.top = 0;
      div.style.bottom = 0;
      div.style.right = 0;
      div.style.padding = 0;
      body.appendChild(div);
      let count = 1;
      _.forEach(imgData, (img) => {
        const image = document.createElement('img');
        image.src = img;
        image.setAttribute('id', `img${count}`);
        image.style.width = '100%';
        // maxHeight for Letter paper height (1054px - 2*48px(narrow margin size))
        image.style.maxHeight = '958px';
        div.insertAdjacentElement('beforeend', image);
        count += 1;
      });
    });

    setSpinnerVisible(false);
    iframe.contentWindow.print();
    iframe.contentWindow.addEventListener('beforeprint', () => {
      const images = iframe.contentWindow.document.querySelectorAll('img');
      _.forEach(images, (img) => {
        const ratio = img.naturalHeight / img.naturalWidth;
        // calculate the bottom margin to be added to image to make each image appear on distinct page
        // 958 is the max height mentioned above
        // 1.29 is the letter size ratio (1054/816)px
        if (ratio < 1.29) {
          const margin = Math.abs(958 - (ratio / 1.29 * 958));
          iframe.contentWindow.document.getElementById(img.id).style.marginBottom = `${margin}px`;
        }
      });
    });
    iframe.contentWindow.addEventListener('afterprint', () => {
      iframe.parentNode.removeChild(iframe);
    });
  };
  return (
    <SiteWrapper
      headerText={
        (
          <div style={{ textAlign: 'center' }}>
            <span>
              {IsLateEntry ? NONMO_USER_ROLE.LateEntryUser : NONMO_USER_ROLE.User}
              {' '}
              Tag Selection
            </span>
          </div>
        )
      }
      totalCount={totalCount}
      showTotalCount
      goBack={IsLateEntry ? 'lateEntryHome' : 'home'}
      TagSelectionPrintButtonVisible={printButtonVisible && isMRATOnline}
      PrintButtonHandler={handlePrintButton}
    >
      <div className="container">
        <Grid container>
          {showGrid && <Grid xs={1} />}
          <Grid xs={2} item style={{ marginTop: '15px' }}>
            <SearchBox
              value={flocSearchString}
              handleSearch={(value) => handleSearch(value, 'FunctionalLocation')}
              name="Functional Location"
              height="27px"
              placeholder="Functional Location"
              fullWidth
              fontSize="7.5pt"
              padding="0px 5px"
              borderColor="var(--primary)"
            />
          </Grid>
          <Grid xs={3} />
          <Grid xs={2} item style={{ marginTop: '15px', marginLeft: '3%' }}>
            <SearchBox
              value={searchByTester}
              handleSearch={(value) => handleSearch(value, 'FirstTestDoneBy')}
              name="First Test Done By"
              height="27px"
              placeholder="First Test Done By"
              fullWidth
              fontSize="7.5pt"
              padding="0px 5px"
              borderColor="var(--primary)"
              marginLeft="1%"
            />
          </Grid>
        </Grid>
        <DarkBackground disappear={!spinnerVisible}>
          <Spinner />
        </DarkBackground>
        <div className="row">
          <div className="col-xs-12">
            <DataTable
              id="TagSelectionNonMOScreenDataTable"
              tableDefinition={updatedTableDefinitionNonMo}
              tableData={getParsedTableData(isMRATOnline, userRole)}
              isLoading={isTableLoading}
              showArrowButton
              sortButtonHandler={sortButtonHandler}
              actionButtonHandler={(dataRow) => handleArrowButton(dataRow, isMRATOnline)}
              height="calc(100vh - 195px)"
              showCheckBox
              printButtonVisible={handlePrintButtonVisible}
              isMRATOnline={isMRATOnline}
              userRole={userRole}
            />
          </div>
        </div>
      </div>
    </SiteWrapper>
  );
};

const mapStateToProps = ({ Home, MOSelection, TagSelectionMOScreen, AppData, TestEquipment, Forms }) => ({
  clearFilters: TagSelectionMOScreen.clearFilters,
  currentView: Home.currentView,
  flocSearchString: TagSelectionMOScreen.flocSearchString,
  selectedRow: MOSelection.selectedRow,
  selectedRowTags: TagSelectionMOScreen.selectedRowTags,
  searchedRowTagsTableData: TagSelectionMOScreen.searchedRowTagsTableData,
  selectedRowTagsTableData: TagSelectionMOScreen.selectedRowTagsTableData,
  totalCount: TagSelectionMOScreen.totalCount,
  userRole: Home.userRole,
  selectedBarrierType: Home.selectedBarrierType,
  isOfflineDataPresent: Home.isOfflineDataPresent,
  isMRATOnline: AppData.isMRATOnline,
  isTableLoading: TagSelectionMOScreen.tableLoading,
  sortHdLocationAscOrder: TagSelectionMOScreen.sortHdLocationAscOrder,
  trfFormImage: Forms.trfFormImage,
  trfMasterList: Home.trfMasterList,
  selectedAssetAliasName: Home.selectedAssetAliasName,
  bpRegionNameAlias: Home.bpRegionNameAlias,
  IsLateEntry: Home.IsLateEntry
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  setCurrentAppView: (view) => dispatch(setCurrentView(view)),
  setPreviousAppScreen: (screen) => dispatch(setPreviousScreen(screen)),
  triggerSearch: (value, hdWorkOrder) => dispatch(searchFLOC(value, hdWorkOrder)),
  triggerSort: (columnName) => dispatch(setHdLocationSortOrder(columnName)),
  initialiseDataForFormTagSelected: (selectedTag) => dispatch(setDataForFormTagSelected(selectedTag)),
  clearTestPointValue: () => dispatch(resetTestPointVal()),
  clearSelectedTRFValue: () => dispatch(clearSelectedTRF()),
  fetchAllImages: () => dispatch(getAllMOImages()),
  deleteSRAData: () => dispatch(clearSRAData()),
  loadP8ITFForm: (selectedTag) => dispatch(GetP8ITFForm(selectedTag)),
  fetchTRFImages: (checkedForm) => dispatch(getPrintImage(checkedForm)),
  setIsEditImage: (isEdit, img) => dispatch(setIsEditimage(isEdit, img)),
  clearEditimageList: () => dispatch(clearEditImageList()),
  saveSpinnerVisible: (spinnerValue) => dispatch(saveSpinnerVisibleData(spinnerValue)),
  checkOfflineFormDataPresent: () => dispatch(checkOfflineDataPresent()),
  homeDraftData: () => dispatch(sendOfflineData()),
  clerLateEntryDpsData: () => dispatch(clearLateEntryDPSData())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TagSelectionMOScreenPage);

TagSelectionMOScreenPage.propTypes = {
  checkOfflineFormDataPresent: PropTypes.func,
  clearEditimageList: PropTypes.func,
  clearFilters: PropTypes.bool,
  clearSelectedTRFValue: PropTypes.func,
  clearTestPointValue: PropTypes.func,
  clerLateEntryDpsData: PropTypes.func,
  deleteSRAData: PropTypes.func,
  fetchAllImages: PropTypes.func,
  fetchTRFImages: PropTypes.func,
  flocSearchString: PropTypes.string,
  homeDraftData: PropTypes.func,
  initialiseDataForFormTagSelected: PropTypes.func,
  IsLateEntry: PropTypes.bool,
  isMRATOnline: PropTypes.bool,
  isOfflineDataPresent: PropTypes.bool,
  isTableLoading: PropTypes.bool,
  loadP8ITFForm: PropTypes.func,
  saveSpinnerVisible: PropTypes.func,
  searchedRowTagsTableData: PropTypes.array,
  selectedRowTags: PropTypes.array,
  selectedRowTagsTableData: PropTypes.array,
  setCurrentAppView: PropTypes.func,
  setIsEditImage: PropTypes.func,
  setPreviousAppScreen: PropTypes.func,
  totalCount: PropTypes.number,
  trfMasterList: PropTypes.array,
  triggerSearch: PropTypes.func,
  triggerSort: PropTypes.func,
  userRole: PropTypes.string
};
